import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2ff8c22e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"
import style0 from "./edit.vue?vue&type=style&index=0&id=2ff8c22e&prod&lang=scss&scoped=true"
import style1 from "./edit.vue?vue&type=style&index=1&id=2ff8c22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8c22e",
  null
  
)

export default component.exports